module.exports = __webpack_public_path__ + "img/appboxo_collection_example.5e9068f4.png";